/*
 * @license
 * Copyright© Celligence LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */
import React, { useEffect, useState, Suspense, lazy } from "react";
import "./App.css";
import "@fontsource/poppins";
import Body from "./components/Body/Body";
import HeaderNav from "./components/Header/index";
import { CookieSetting } from "cookiesetting-component";
import axios from "axios";

export default function App() {
  return (
    <>
      <HeaderNav />
      <Body />
      <CookieSetting
        privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK}
        configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
        analytics={process.env.REACT_APP_ANALYTICS_PATH}
      />
    </>
  );
}

